import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6883c888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-flex jr-fixed jr-w-full jr-h-full" }
const _hoisted_2 = { class: "jr-table-fixed jr-w-full jr-border-collapse" }
const _hoisted_3 = {
  width: "65%",
  class: "jr-border-b jr-border-gray jr-pb-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "jr-text-right jr-text-xs jr-font-normal jr-text-gray-dark jr-border-b jr-border-gray jr-pb-2",
  width: "20%"
}, "構成比率", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "jr-text-right jr-text-xs jr-font-normal jr-text-gray-dark jr-border-b jr-border-gray jr-pb-2",
  width: "15%"
}, "ピン", -1))
const _hoisted_6 = {
  width: "65%",
  class: "jr-py-2"
}
const _hoisted_7 = {
  class: "jr-text-right jr-text-s jr-text-primary jr-py-2",
  width: "20%"
}
const _hoisted_8 = {
  class: "jr-text-center jr-py-2",
  width: "15%"
}
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UILayerToggle = _resolveComponent("UILayerToggle")!
  const _component_FacilityIndicator = _resolveComponent("FacilityIndicator")!
  const _component_UIGoogleMap = _resolveComponent("UIGoogleMap")!
  const _component_UICheckbox = _resolveComponent("UICheckbox")!
  const _component_AreaSearchFilter = _resolveComponent("AreaSearchFilter")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UIGoogleMap, {
      onLoad: _ctx.handleMapLoad,
      right: _ctx.captureClip ? 336 : _ctx.filterMinimum ? 390 : 620,
      class: _normalizeClass(["jr-absolute jr-w-full", { 'content': !_ctx.captureClip, 'jr-h-screen': _ctx.captureClip }])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UILayerToggle, {
          class: "transition jr-absolute jr-top-2",
          "data-html2canvas-ignore": "true",
          label: "選択したエリア",
          onToggle: _ctx.handleAreaToggle,
          style: _normalizeStyle({ right: _ctx.captureClip ? '336px' : _ctx.filterMinimum ? '394px' : '620px' })
        }, null, 8, ["onToggle", "style"]),
        _createVNode(_component_FacilityIndicator, {
          class: _normalizeClass(["transition-indicator jr-absolute jr-bottom-3.9", { 'jr-shadow-lg': !_ctx.captureClip }]),
          style: _normalizeStyle({ left: _ctx.captureClip ? '10px' : _ctx.sbMinimum ? '74px' : '250px' })
        }, null, 8, ["class", "style"])
      ]),
      _: 1
    }, 8, ["onLoad", "right", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(["jr-w-area-worker transition jr-fixed jr-z-10 jr-bg-white jr-py-7.5 jr-px-6.5 jr-overflow-scroll", { 'content': !_ctx.captureClip, 'jr-h-screen': _ctx.captureClip }]),
      style: _normalizeStyle({ right: _ctx.captureClip ? '0' : _ctx.filterMinimum ? '60px' : '292px' })
    }, [
      _createElementVNode("h1", {
        class: _normalizeClass(["jr-text-primary jr-text-lg jr-font-medium jr-mb-5", { 'jr-pt-18': _ctx.captureClip }])
      }, "訪問施設ランキング", 2),
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_3, [
              _createVNode(_component_UICheckbox, {
                icon: "minus",
                label: "カテゴリ名",
                "label-classes": "jr-text-gray-dark jr-text-xs jr-font-normal",
                modelValue: _ctx.isAllFacilitySelect,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAllFacilitySelect) = $event)),
                onChange: _ctx.onAllFacilityChange
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _hoisted_4,
            _hoisted_5
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pins, (pin, name, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_UICheckbox, {
                  label: `${index + 1}. ${name}`,
                  "label-classes": "jr-text-xs",
                  onChange: _ctx.onFacilityChange,
                  modelValue: _ctx.pinModel[name],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.pinModel[name]) = $event)
                }, null, 8, ["label", "onChange", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("td", _hoisted_7, _toDisplayString(pin[0]) + "%", 1),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("img", {
                  class: "jr-float-right",
                  src: _ctx.pinMaster[name],
                  alt: "facility pin"
                }, null, 8, _hoisted_9)
              ])
            ]))
          }), 128))
        ])
      ])
    ], 6),
    _createVNode(_component_AreaSearchFilter, {
      onSearch: _ctx.handleSearch,
      onResize: _ctx.handleFilterResize
    }, null, 8, ["onSearch", "onResize"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}